var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('a',{attrs:{"href":_vm.l.url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.cdn + '/img/rensai/interview/' + _vm.l.img}}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.l.title))]),_vm._v(" "),_c('p',{staticClass:"dt"},[_vm._v(_vm._s(_vm.dtFmt(_vm.l.dt)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }